import { DebugService } from '@services/debug.service';
import { SessionService } from '@services/session.service';
import { Router } from './router.js';
import { RefiSession } from '@models/refi-session.js';
import { HostAppEventsService } from '@services/host-app-events.service.ts';
import { getIsV2Routing } from '@services/routing-v2.service.ts';

class _AppService {
  _status: string;
  debug: DebugService;
  session: RefiSession;
  constructor() {
    this.debug = new DebugService('AppService');
    this.session = SessionService.session || {};
    this._status = '';
    document.dispatchEvent(
      new CustomEvent('glia-add-custom-attributes', {
        detail: { AppId: this.session.currentApp?.appId || '' },
      })
    );
  }

  get status() {
    this.debug.log('getting status', this._status);
    return this._status;
  }

  set status(status) {
    this._status = status;
  }

  updateState({ statFlag = this.session.currentApp.statFlag }) {
    this.debug.log('updateState called with', {
      statFlag,
    });
    SessionService.updateStatFlag(statFlag);
  }

  updateRoute() {
    this._status = 'lender-info';
    if (getIsV2Routing()) {
      HostAppEventsService.sendNextStepEvent(this._status);
    } else {
      Router.goTo(`${this._status}`);
      Router.sendStateChangedEvent();
    }
  }
}

export const AppService = new _AppService();
